var _excluded = ["appearance", "background"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { useBackground } from '../utils';
import propTypes from '../prop_types';
import useStyles from '../use_styles';
import logo from '@veneer/logos/hp/hp.svg';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LogoHp = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      appearance = 'multicolor',
      background: backgroundProp = 'auto'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var background = useBackground(backgroundProp);
  var styles = useStyles(props);
  return ___EmotionJSX("img", _extends({
    alt: "HP Logo",
    css: styles,
    src: "".concat(logo, "#").concat(appearance, "-").concat(background),
    ref: ref
  }, props));
});
LogoHp.displayName = 'LogoHp';
LogoHp.propTypes = propTypes;
export default LogoHp;